/* src/app/pages/casos/paso4/paso4.component.scss */
/*# sourceMappingURL=paso4.component.css.map */
